module.exports = __webpack_public_path__ + "img/linked.09ec3ec0.png";